import React from 'react';

const UmpanBalik360 = React.lazy(() => import('./UmpanBalik360'))
const FormPenilaian = React.lazy(() => import('./FormPenilaian'))

export const umpanBalik360Configs = [
    {
        path: '/umpan-balik-360',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/dashboard/admin',
        element: <UmpanBalik360 />,
        permittedRole: ['Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/dashboard/individual',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/daftar-penilaian',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/penilaian/:idEvaluatee/:relation/:isPimpinan',
        element: <FormPenilaian />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/penilaian/detail/:idEvaluatee/:relation',
        element: <FormPenilaian />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/penilaian/edit/:idEvaluatee/:relation',
        element: <FormPenilaian />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/admin-pertanyaan',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/generate-penilaian',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/evaluator',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/role-akses',
        element: <UmpanBalik360 />,
        permittedRole: ['Pegawai', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
    {
        path: '/umpan-balik-360/quarter',
        element: <UmpanBalik360 />,
        permittedRole: ['Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360'],
    },
]